module.exports = __webpack_public_path__ + "public/img/Padlock.532deb92.svg";